<!-- LISTING DETAILS/NO PHOTO -->
<p>LISTING DETAILS/NO PHOTO</p>
<div class="col-lg-12 empty-photo empty-photo--details text-center">
    <svg width="150px" height="150px" viewBox="0 0 150 150" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
            <circle id="path-1" cx="75" cy="75" r="75"></circle>
        </defs>
        <g id="Empty-States" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Desktop-HD" transform="translate(-640.000000, -355.000000)">
                <g id="item-pic" transform="translate(50.000000, 140.000000)">
                    <g id="Group-2" transform="translate(494.000000, 215.000000)">
                        <g id="Group-3" transform="translate(96.000000, 0.000000)">
                            <mask id="mask-2" fill="white">
                                <use xlink:href="#path-1"></use>
                            </mask>
                            <use id="Oval" fill-opacity="0.0493607955" fill="#000000" opacity="0.4"
                                xlink:href="#path-1"></use>
                            <g id="Group" mask="url(#mask-2)">
                                <g transform="translate(39.375000, 50.625000)">
                                    <polygon id="Rectangle" stroke="none" fill="#D9D9D9"
                                        points="38.7096774 2.34604106 46.9208211 36.8955875 55.1319648 58.6510264 29.9120235 58.6510264">
                                    </polygon>
                                    <path
                                        d="M51.1730205,58.973607 L51.1730205,110.791789 L23.9002933,110.791789 L23.9002933,76.7008798 L14.3839448,76.519894 C6.39604856,76.367977 2.76237646e-14,69.8491291 2.13162821e-14,61.8597884 L2.13162821e-14,31.6715543 L2.13162821e-14,31.6715543 L13.4897361,31.6715543 L13.4897361,59.8240469 C13.4897361,61.767571 15.0652736,63.3431085 17.0087977,63.3431085 L22.8739003,63.3431085 L22.8739003,63.3431085 L22.8739003,7.10542736e-15 L51.6129032,7.10542736e-15 L51.6129032,45.7478006 L57.4780059,45.7478006 C59.4215299,45.7478006 60.9970674,44.172263 60.9970674,42.228739 L60.9970674,16.4222874 L60.9970674,16.4222874 L74.4868035,16.4222874 L74.4868035,44.5747801 C74.4868035,52.6727969 67.9220638,59.2375367 59.8240469,59.2375367 L38.1231672,59.2375367 L38.1231672,59.2375367 L38.1231672,17.5953079"
                                        id="Path-25" stroke="#B0B0B0" stroke-width="5.86510264" fill="#D9D9D9">
                                    </path>
                                    <rect id="Rectangle" stroke="none" fill="#D9D9D9" x="33.431085" y="28.1524927"
                                        width="9.38416422" height="8.79765396"></rect>
                                    <circle id="Oval" stroke="none" fill="#B0B0B0" cx="38.1231672" cy="15.2492669"
                                        r="4.69208211"></circle>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
    <h5 class="rui-pt-sm">Oops! No photo found</h5>
    <p>
        We will see to it that this gets updated right away
    </p>
</div>
<!-- END OF LISTING DETAILS/NO PHOTO -->
<br><br>
<div class="row">
    <div class="col-lg-4">
        <p>LISTING ITEM/NO PHOTO</p>
    </div>
    <div class="col-lg-8">
        <p>LISTING ITEM/LAZY LOAD</p>
    </div>
</div>
<div class="row">
    <div class="col-lg-4">
        <div class="listing">
            <div class="empty-photo empty-photo--single">
                <p>Electric Scooter XIAOMI M365</p>
            </div>
            <label class="price">$3 /day</label>
            <div class="rating"><i _ngcontent-qet-c4="" class="fa fa-star"></i><i _ngcontent-qet-c4=""
                    class="fa fa-star"></i><i _ngcontent-qet-c4="" class="fa fa-star"></i><i _ngcontent-qet-c4=""
                    class="fa fa-star"></i><i _ngcontent-qet-c4="" class="fa fa-star"></i></div>
            <label _ngcontent-qet-c4="" class="title">Bread</label><label _ngcontent-qet-c4="" class="location pin"><img
                    _ngcontent-qet-c4="" src="cmap-pin.svg"> Cebu City, Cebu, Philippines </label>
        </div>
    </div>
    <div class="col-lg-8">
        <div class="listing lazy-load lazy-load--listing">
            <div class="empty-photo empty-photo--single">
            </div>
            <label class="price"></label>
            <div class="rating"></div>
            <label class="title"></label>
            <label class="location pin"></label>
        </div>
        <div class="listing lazy-load lazy-load--listing">
            <div class="empty-photo empty-photo--single">
            </div>
            <label class="price"></label>
            <div class="rating"></div>
            <label class="title"></label>
            <label class="location pin"></label>
        </div>
        <div class="listing lazy-load lazy-load--listing">
            <div class="empty-photo empty-photo--single">
            </div>
            <label class="price"></label>
            <div class="rating"></div>
            <label class="title"></label>
            <label class="location pin"></label>
        </div>
    </div>
</div>
<br><br>
<div class="row">
    <div class="col-lg-12">
        <p>SEARCH ITEM/RESULT + IMAGE LOADING</p>
    </div>
</div>
<div class="col-lg-12 " style="padding-left: 20px;padding-bottom: 100px;">
    <nav style="color: #FFFFFF;padding-left: 20px;">
        //Search bar here...
    </nav>
    <div class="restaurant-lookup">
        <div class="selectionWrapper open" style="width: 500px;">
            <div class="skeleton skeleton-active">
                <div class="skeleton-content">
                    <ul class="skeleton-paragraph lazy-load lazy-load--result-txt lazy-load--result-img">
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<br><br>
<div class="row">
    <div class="col-lg-12">
        <p>SEARCH ITEM/IMAGE ONLY LOADING</p>
    </div>
</div>
<div class="col-lg-12 " style="padding-left: 20px;padding-bottom: 100px;">
    <nav style="color: #FFFFFF;padding-left: 20px;">
        //Search bar here...
    </nav>
    <div class="restaurant-lookup">
        <div class="selectionWrapper open" style="width: 500px;">
            <div class="skeleton skeleton-active">
                <div class="skeleton-content">
                    <ul class="skeleton-paragraph lazy-load lazy-load--result-img">
                        <li>
                            <!-- <img class="mr-2" applazyload="" height="30px" width="30px" ng-reflect-use-gif-loader="true"
                                src="https://firebasestorage.googleapis.com/v0/b/rent-it-c30c8.appspot.com/o/listing-images%2F1602951184307_4.jpg?alt=media&amp;token=0dc17f3f-25e9-4432-9689-7eefe5cbe713"> -->
                            Product Name
                        </li>
                        <li>
                            <!-- <img class="mr-2" applazyload="" height="30px" width="30px"
                                src="https://firebasestorage.googleapis.com/v0/b/rent-it-c30c8.appspot.com/o/listing-images%2F1602951184307_4.jpg?alt=media&amp;token=0dc17f3f-25e9-4432-9689-7eefe5cbe713"> -->
                            This is a product name
                        </li>
                        <li>
                            <!-- <img class="mr-2" applazyload="" height="30px" width="30px"
                                src="https://firebasestorage.googleapis.com/v0/b/rent-it-c30c8.appspot.com/o/listing-images%2F1602951184307_4.jpg?alt=media&amp;token=0dc17f3f-25e9-4432-9689-7eefe5cbe713"> -->
                            This is a very long product name and should be truncated that needs to be
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<br><br>
<div class="row">
    <div class="col-lg-12">
        <p>NO REVIEWS</p>
    </div>
    <div class="col-lg-12">
        <section class="empty-section">
            <svg id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"
                xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="m136.151 195.526c-1.765 5.43-.293 11.391 3.795 15.377l47.145 45.957-11.129 64.887c-.965 5.628 1.349 11.315 5.967 14.671 2.614 1.899 5.708 2.865 8.819 2.865 2.387 0 4.783-.569 6.978-1.723l58.276-30.636 58.275 30.636c2.194 1.153 4.591 1.723 6.978 1.723h.051c8.271-.016 14.971-6.726 14.971-15 0-1.152-.129-2.273-.375-3.351l-10.99-64.072 47.146-45.957c4.088-3.985 5.56-9.946 3.795-15.376s-6.459-9.388-12.109-10.209l-65.152-9.466-29.137-59.04c-2.527-5.12-7.741-8.362-13.451-8.362-5.709 0-10.925 3.242-13.451 8.361l-29.138 59.041-65.151 9.466c-5.654.821-10.349 4.777-12.113 10.208zm89.377 8.88c4.886-.71 9.11-3.778 11.295-8.205l19.177-38.856 19.176 38.857c2.185 4.427 6.408 7.496 11.295 8.206l42.879 6.23-31.028 30.246c-3.535 3.446-5.148 8.411-4.313 13.277l7.325 42.705-38.354-20.163c-4.369-2.297-9.59-2.297-13.959 0l-38.354 20.163 7.324-42.705c.835-4.866-.778-9.831-4.313-13.277l-31.027-30.246z" />
                    <path
                        d="m501.638 224.564c-1.52-.495-15.307-4.831-31.049-4.831-9.854 0-18.499 1.731-25.775 5.133-.146-2.516-.327-5.026-.572-7.529 12.353-3.494 29.186-10.53 38.752-24.191 15.448-22.057 8.188-56.028 7.309-59.829-1.728-7.477-8.812-12.449-16.437-11.51-3.685.451-35.007 4.826-51.341 24.261-1.118-2.073-2.267-4.132-3.465-6.165-.08-.136-.167-.269-.247-.404 9.715-8.387 21.983-21.872 24.88-38.287 4.675-26.524-16.26-54.239-18.662-57.312-4.727-6.045-13.253-7.549-19.762-3.484-3.15 1.967-29.71 19.185-36.286 43.721-5.879-4.388-12.006-8.459-18.379-12.147-7.165-4.147-16.345-1.701-20.495 5.47-4.15 7.17-1.701 16.347 5.47 20.496 13.498 7.811 25.579 17.478 36.012 28.558 27.427 28.7 44.273 67.597 44.273 110.43 0 88.291-71.574 159.864-159.864 159.864s-159.862-71.573-159.862-159.863c0-42.793 16.814-81.658 44.196-110.351 10.452-11.113 22.558-20.808 36.09-28.636 7.171-4.148 9.62-13.325 5.472-20.495-4.148-7.171-13.323-9.621-20.495-5.473-6.375 3.688-12.503 7.759-18.384 12.147-6.572-24.536-33.136-41.754-36.286-43.721-6.51-4.064-15.035-2.56-19.761 3.484-2.403 3.073-23.339 30.788-18.663 57.314 2.896 16.413 15.164 29.897 24.88 38.284-.08.135-.166.267-.246.402-1.199 2.034-2.348 4.093-3.467 6.167-16.336-19.436-47.656-23.811-51.341-24.261-7.609-.931-14.708 4.034-16.437 11.511-.878 3.801-8.135 37.77 7.311 59.826 9.566 13.662 26.399 20.699 38.752 24.193-.245 2.503-.427 5.014-.572 7.529-7.274-3.401-15.919-5.133-25.774-5.133-15.742 0-29.529 4.337-31.05 4.831-7.298 2.374-11.627 9.873-10.033 17.379.81 3.816 8.587 37.667 31.911 51.136 7.926 4.574 17.747 6.893 29.191 6.894h.005c5.822 0 11.374-.594 16.139-1.366.839 2.378 1.718 4.737 2.649 7.07-.009 0-.017 0-.025 0-25.386 0-48.973 21.321-51.578 23.753-5.611 5.235-6.366 13.861-1.75 19.992 2.347 3.116 23.702 30.512 50.531 32.858 1.272.111 2.58.168 3.886.168h.004c15.249 0 29.842-7.691 39.634-14.361 1.766 1.803 3.563 3.573 5.399 5.305-23.073 10.701-35.447 39.918-36.839 43.367-2.873 7.117.09 15.254 6.866 18.858 2.175 1.157 21.839 11.3 42.291 11.302h.005c6.285 0 12.134-.968 17.385-2.878 15.671-5.706 26.825-20.145 33.396-31.173 5.389 2.033 10.893 3.827 16.503 5.368-8.73 8.875-16.727 20.176-23.742 33.73-3.808 7.358-.931 16.409 6.427 20.216 2.204 1.141 4.561 1.682 6.882 1.682 5.428 0 10.667-2.955 13.334-8.108 13.414-25.917 30.606-40.781 47.171-40.781 16.564 0 33.757 14.864 47.172 40.781 3.808 7.356 12.856 10.237 20.217 6.426 7.357-3.808 10.233-12.859 6.426-20.216-7.016-13.555-15.013-24.855-23.743-33.73 5.608-1.541 11.113-3.334 16.502-5.367 6.571 11.028 17.727 25.468 33.401 31.174 5.248 1.909 11.097 2.877 17.385 2.877 20.453 0 40.117-10.146 42.292-11.302 6.776-3.604 9.738-11.742 6.865-18.858-1.392-3.449-13.768-32.665-36.84-43.365 1.836-1.732 3.635-3.502 5.4-5.305 9.793 6.67 24.387 14.361 39.636 14.361 1.305 0 2.612-.057 3.888-.168 26.827-2.346 48.183-29.743 50.529-32.858 4.616-6.13 3.861-14.756-1.75-19.992-2.605-2.431-26.191-23.753-51.577-23.753-.009 0-.017 0-.025 0 .931-2.333 1.81-4.692 2.648-7.07 4.766.772 10.319 1.366 16.143 1.366 11.444 0 21.266-2.319 29.195-6.896 23.32-13.467 31.099-47.318 31.908-51.133 1.588-7.509-2.741-15.008-10.039-17.382zm-87.488-128.561c-1.038 5.882-6.022 12.361-11.616 17.773-3.34-6.858-5.911-14.698-4.856-20.679 1.038-5.888 6.032-12.374 11.626-17.785 3.409 7.003 5.883 14.804 4.846 20.691zm-311.455-20.692c5.599 5.414 10.591 11.898 11.628 17.785 1.038 5.886-1.435 13.687-4.844 20.69-5.599-5.414-10.59-11.897-11.628-17.782-1.038-5.89 1.437-13.694 4.844-20.693zm-41.258 194.662c-.001 0-.003 0-.003 0-6.027 0-10.937-.995-14.194-2.875-5.172-2.986-9.554-9.882-12.725-16.98 2.21-.235 4.54-.385 6.897-.385 6.022 0 10.93.995 14.188 2.876 5.17 2.986 9.552 9.882 12.722 16.98-2.21.235-4.536.384-6.885.384zm10.196-82.831c-7.362-2.542-14.625-6.309-18.053-11.205-3.43-4.896-4.484-13.015-4.356-20.797 7.362 2.541 14.626 6.308 18.056 11.205 3.428 4.896 4.483 13.01 4.353 20.797zm9.655 165.304c-.438 0-.867-.018-1.275-.054-5.944-.52-12.826-4.914-18.697-10.003 5.938-3.583 12.904-6.714 18.882-6.714.438 0 .866.018 1.274.054 5.945.52 12.827 4.915 18.698 10.005-5.936 3.582-12.903 6.712-18.882 6.712zm64.484 63.4c-1.951.71-4.348 1.069-7.126 1.069h-.002c-4.583 0-9.544-.984-14.065-2.286 4.355-6.438 9.863-12.459 15.469-14.499 1.952-.71 4.352-1.071 7.133-1.071 4.581 0 9.539.983 14.059 2.284-4.358 6.441-9.865 12.463-15.468 14.503zm241.653-1.217c-4.52 1.3-9.486 2.287-14.065 2.287-2.779 0-5.178-.36-7.126-1.068-5.608-2.041-11.118-8.066-15.473-14.503 4.522-1.302 9.48-2.285 14.061-2.285 2.781 0 5.182.36 7.136 1.071 5.605 2.04 11.113 8.063 15.467 14.498zm44.379-78.954c5.977 0 12.945 3.132 18.88 6.712-5.874 5.093-12.753 9.485-18.695 10.005-.409.036-.839.054-1.275.054-5.975 0-12.938-3.127-18.869-6.703 5.752-4.989 12.645-9.485 18.684-10.014.409-.036.838-.054 1.275-.054zm12.917-169.331c3.427-4.895 10.688-8.662 18.039-11.202.129 7.626-.854 15.819-4.339 20.794-3.429 4.896-10.692 8.664-18.055 11.206-.13-7.787.926-15.901 4.355-20.798zm20.043 100.751c-3.262 1.882-8.171 2.877-14.196 2.877-2.347 0-4.669-.148-6.873-.383 3.105-6.956 7.452-13.947 12.703-16.98 3.261-1.882 8.168-2.877 14.191-2.877 2.355 0 4.684.149 6.895.386-3.172 7.102-7.552 13.993-12.72 16.977z" />
                </g>
            </svg>
            <div>
                <h5>No reviews added yet!</h5>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.
                </p>
            </div>
        </section>
    </div>
</div>
<br><br>
<div class="row">
    <div class="col-lg-12">
        <p>LISTING DETAILS PAGE</p>
    </div>
    <section class="container lazy-load lazy-load--listing-details" style="width: 100%;">
        <div class="row">
            <label class="directory"></label>
            <h4></h4>
            <div class="col-lg-12 empty-photo empty-photo--details text-center">
            </div>
        </div>
        <div class="row">
            <div class="col-lg-7">
                <div class="row lazy-load--listing-details__section">
                    <div class="col-lg-12">
                        <h5></h5>
                        <p></p>
                        <p></p>
                    </div>
                    <div class="col-lg-12">
                        <h5></h5>
                        <p></p>
                        <p></p>
                    </div>
                    <div class="col-lg-12">
                        <h5></h5>
                        <p></p>
                        <p></p>
                    </div>
                    <div class="col-lg-12">
                        <h5></h5>
                        <p></p>
                        <p></p>
                    </div>
                    <div class="col-lg-12">
                        <h5></h5>
                        <p></p>
                        <p></p>
                    </div>
                </div>
            </div>
            <div class="col-lg-5">
                <div class="price-detail-wrap">
                    <div class="row lazy-load--listing-details__section">
                        <div class="col-lg-12">
                            <h5></h5>
                            <p></p>
                            <p></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>